import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

export const LineChart = ({ chartData }) => {
  const data = {
    // labels: ["2020", "2021", "2022", "2023", "2024"],
    labels: chartData?.map((item) => item.years.toString()), // Extract years as labels
    datasets: [
      {
        label: "Strength",
        // data: [500, 550, 470, 380, 586],
        data: chartData?.map((item) => item.strength), // Map strength data
        borderColor: "rgba(75,192,192,1)",
        backgroundColor: "rgba(75,192,192,0.2)",
        fill: false,
        tension: 0.1,
      },
      {
        label: "Capacity",
        // data: [600, 650, 700, 750, 700],
        data: chartData?.map((item) => item.capacity), // Map capacity data
        borderColor: "rgba(255,165,0,1)",
        backgroundColor: "rgba(255,165,0,0.2)",
        fill: false,
        tension: 0.1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 20,
          boxHeight: 0,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Years",
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Strength",
        },
      },
    },
  };

  return (
    <>
      <Line options={options} data={data} />
    </>
  );
};
